import Image from "next/image";
import {useTranslation} from "next-i18next";
import IconFax from "../../data/Icons/icon-fax.svg";
import IconPhone from "../../data/Icons/icon-phone.svg";

interface TeamMember{
    name: string;
    position: string;
    image: string;
    languages: string;
    phone: string;
    fax: string;
    email: string;
}

export default function UnserTeam(){
    const { t } = useTranslation("team");
    const members = t("team:team", { returnObjects: true }) as TeamMember[];

    return (
        <div>
            <h2 className="text-center font-light mb-8">{t("heading")}</h2>
            <div className="flex flex-wrap gap-12">
                {members.map((member, i) => (
                    <div key={i} className="border p-4 flex bg-white w-full lg:w-[calc(50%-24px)] gap-5 rounded-[20px] shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)]">
                        <div className="relative aspect-[850/1000] h-full w-1/2">
                            <Image
                                src={member.image}
                                alt={member.name}
                                fill
                                className="rounded-tl-[20px] rounded-bl-[20px]"
                            />
                        </div>
                        <div className="w-1/2 flex flex-col justify-between pb-2 lg:pb-4">
                            <div>
                                <h3 className="font-normal text-[20px] lg:text-[32px] mb-1">{member.name}</h3>
                                <p className="uppercase text-[12px] lg:text-[18px] leading-[1.2]">{member.position}</p>
                            </div>
                            <p className="mt-1 lg:mt-2 text-[10px] lg:text-[16px] font-normal text-[#a3a3a3] leading-[1.2]">
                                <span>{t("language")}: </span>
                                <span>{member.languages}</span>
                            </p>
                            <div>
                                <div className="flex items-center gap-2">
                                    <div className="w-3 h-3 lg:w-4 lg:h-4">
                                        <IconPhone />
                                    </div>
                                    <span className="text-leo-brown text-[16px] lg:text-[20px]">{member.phone}</span>
                                </div>
                                {member.fax && (
                                    <div className="flex items-center gap-2">
                                        <div className="w-3 h-3 lg:w-4 lg:h-4">
                                            <IconFax />
                                        </div>
                                        <span className="text-leo-brown text-[14px] lg:text-[16px]">{member.fax}</span>
                                    </div>
                                )}
                                <a className="w-[120px] lg:w-[180px] h-[32px] lg:h-[40px] mt-2 lg:mt-4 text-[12px] lg:text-[16px] font-bold flex justify-center items-center text-white rounded-[10px] bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent uppercase" href={`mailto:${member.email}`}>
                                    <span>{t("email")}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}